import { AppSettings } from "../constants";
import Jwt from "../helper/interceptors";
import { ObjToParam, MapResponse } from "../helper/helper-api";
import removeDiacritics from "../helper/remove-diacritics";
import { v4 as uuidv4 } from "uuid";
import S3 from "aws-sdk/clients/s3";
import { config, Credentials } from "aws-sdk/lib/core";

export const getById = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params }],
  })
    .get(`/api/lots/${params}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const create = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post("/api/lots", params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const update = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.id }],
  })
    .put("/api/lots", params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const search = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/lots/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const remove = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .delete(`/api/lots/${params}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const importLot = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, "multipart/form-data")
    .post("/api/lots/import", params.data, {
      headers: { "Content-Type": "multipart/form-data", Key: params.projectId },
    })
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const selectRoom = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: "Key", value: params.id }],
  })
    .get(`/api/lots/${params.id}/rooms-select-list?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const selectTrade = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: "Key", value: params.id }],
  })
    .get(`/api/lots/${params.id}/trades-select-list?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getLotTab = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.projectId }],
  })
    .get(`/api/projects/${params.projectId}/lots?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const checkHomeownerExistingByEmail = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(
      `/api/lots/check-home-owner-existing-by-email/${params.lotId}/${params.email}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const inviteHomeowner = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .post("/api/lots/invite-homeowner", params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setNewOwnershipToLot = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(`/api/lots/${params.lotId}/ownerships`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updatePurchaseDateToLot = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(`/api/lots/${params.lotId}/ownerships/purchase-date`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addMoreHomeownerToLot = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(`/api/lots/${params.lotId}/ownerships/add-homeowner`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resetPrimaryHomeownerToLot = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(`/api/lots/${params.lotId}/ownerships/primary`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setAllWarrantyAccessToHomeowner = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(
      `/api/lots/${params.lotId}/ownerships/all-warranty-access`,
      params.data
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerLotList = () => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get("/apiv1/homeowners/lots")
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerLotRFSStatus = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post("/api/v1/ho/lotpaidfeature/get-ho-lot-rfs", params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      /**
       * No response at all (network/CORS failure) - keep a usable shape
       * so the caller can fail closed instead of throwing
       */
      if (!response) {
        return { data: null, statusCode: 0 };
      }
      return MapResponse(response);
    });
};

export const getHomeownerLotDetail = (params) => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }],
  })
    .get(params.endpoint, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSubcontractorLotDetail = (params) => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }],
  })
    .get(params.endpoint, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchRFSLot = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.id }],
  })
    .get(
      `/api/lots/${params.id}/request-for-services?${ObjToParam(params.param)}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchHomeownerRFSLot = (params) => {
  // return Jwt(null, true, {headers: [{key: params.headers.key, value: params.headers.value}]})
  //   .get(`${params.builderHost}/api/portal-homeowners/lots/${params.lotId}/request-for-services?${ObjToParam(params.param)}`)
  const partUri = params.isHomeowner ? "owner" : "tenancies";
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .get(
      `apiv1/homeowners/lots/${
        params.lotId
      }/request-for-services-${partUri}?${ObjToParam(params.param)}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setupLotDocumentAWS = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post("/api/aws/s3/credentials", params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadLotDocumentToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken,
  });

  const fileName = removeDiacritics(params.file.name);
  const enFileName = uuidv4() + "." + fileName.split(".").pop();
  const s3 = new S3({ region: params.config.region });

  const payload = {
    ACL: "public-read",
    Body: params.file,
    Bucket: params.config.bucket,
    ContentType: params.file.type,
    ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${enFileName}`,
  };
  let upload = s3.upload(payload);
  let isDelete = false;
  upload.send((error, data) => {
    if (data) {
      /**
       * callback delete file after upload file success
       */
      if (isDelete) {
        const bucketInstance = new S3({ region: params.config.region });
        bucketInstance.deleteObject(
          {
            Bucket: params.config.bucket,
            Key: `${params.config.path}/${enFileName}`,
          },
          (err, res) => {
            if (res) {
              if (process.env.NODE_ENV === "development") {
                console.log("File deleted successfully");
              }
            } else {
              if (process.env.NODE_ENV === "development") {
                console.log(
                  "Check if you have sufficient permissions : " + err
                );
              }
            }
          }
        );
      } else {
        callback(true, { data, lotId: params.lotId });
      }
    } else {
      /**
       * callback when upload file success
       */
      callback(false, { data, lotId: params.lotId });
    }
  });
  /**
   * callback when user cancel uploading file
   */
  const cancelUpload = () => {
    setTimeout(upload.abort.bind(upload), 100);
  };
  const deleteFile = () => {
    isDelete = true;
  };
  if (params.file.size > 1024 * 1024 * 5) {
    callback("pending", {
      cancelUpload,
      uploadId: params.file.uploadId,
      fileName,
    });
  } else {
    callback("delete", {
      deleteFile,
      uploadId: params.file.uploadId,
      fileName,
    });
  }
};

export const uploadLotDocumentToServer = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .post(`/api/lots/${params.lotId}/documents`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getLotDocument = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .get(`/api/lots/${params.lotId}/documents`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const downloadLotDocument = (params) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken,
  });

  const bucketInstance = new S3({ region: params.config.region });
  bucketInstance.getObject(
    {
      Bucket: params.config.bucket,
      Key: params.key,
    },
    (err, res) => {
      if (res) {
        var blob = new Blob([res.Body], { type: res.ContentType });
        var filename = params.fileName;

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(blob, filename);
        } else {
          var URL = window.URL || window.webkitURL;
          var downloadUrl = URL.createObjectURL(blob);

          if (filename) {
            // use HTML5 a[download] attribute to specify filename
            var a = document.createElement("a");
            // safari doesn't support this yet
            if (typeof a.download === "undefined") {
              window.location = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location = downloadUrl;
          }

          setTimeout(() => {
            URL.revokeObjectURL(downloadUrl);
          }, 100); // cleanup
        }
      } else {
        if (process.env.NODE_ENV === "development") {
          console.log("Check if you have sufficient permissions : " + err);
        }
      }
    }
  );
};

export const removeLotDocument = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.id }],
  })
    .delete(`/api/lots/${params.id}/documents/${params.docId}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getLotNotes = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .get(`/api/lots/${params.lotId}/notes`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addLotNotes = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .post(`/api/lots/${params.lotId}/notes`, params.params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editLotNotes = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(`/api/lots/${params.lotId}/notes/${params.id}`, params.params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteLotNotes = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .delete(`/api/lots/${params.lotId}/notes/${params.id}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const checkTenancyExistingByEmail = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .put(
      `/api/lots/check-tenancy-existing-by-email/${params.lotId}/${params.email}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setNewLotTenancy = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .post(`/api/lots/${params.lotId}/tenancy`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const inviteLotTenancy = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .post("/api/lots/invite-tenancy", params)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setLotPrimaryContact = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.id }],
  })
    .put(
      `/api/lots/${params.id}/set-primary-contact/${params.isTenancyContact}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const removeTenancy = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.id }],
  })
    .delete(`/api/lots/${params.id}/tenancy/${params.tenancyId}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerLotDocument = (params) => {
  return Jwt(null, true, {
    headers: [{ key: params.headers.key, value: params.headers.value }],
  })
    .get(
      `${params.endpoint}/api/portal-homeowners/lots/${params.lotId}/documents`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setupHomeownerLotDocumentAWS = (params) => {
  return Jwt(null, false, {
    headers: [{ key: params.headers.key, value: params.headers.value }],
  })
    .post(`${params.endpoint}/api/aws/s3/credentials`, params.param)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getLotLocations = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: "Key", value: params.lotId }],
  })
    .get(`/api/lots/${params.lotId}/locations`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerLotLocations = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .get(
      `${params.builderHost}/api/portal-homeowners/lots/${params.lotId}/locations`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListHomeownerLot = () => {
  return Jwt(AppSettings.GLOBAL_API_URL, false)
    .get("/apiv1/homeowners/lot-select-list")
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerDocumentCategory = (params) => {
  return Jwt(params.headers.url)
    .get(`/api/v2/homeowner/documents/category/lot/${params.lotId}/all`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getDocumentByCategory = (params) => {
  return Jwt(params.url)
    .post(`/api/v2/homeowner/documents/all`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadDocumentByCategory = (params) => {
  return Jwt(params.headers.url, "multipart/form-data")
    .post("/api/v2/homeowner/documents/add", params.data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteHomeownerDocument = (params) => {
  return Jwt(params.headers.url)
    .get(`/api/v2/homeowner/documents/delete?documentId=${params.documentID}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editDocumentByCategory = (params) => {
  return Jwt(params.headers.url)
    .post("/api/v2/homeowner/documents/update", params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteHomeownDocument = (params) => {
  return Jwt(params.headers.url)
    .post(
      `/api/v2/homeowner/documents/delete?documentId=${params.documentID}`,
      params.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListHomeownerDocumentType = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .get(params.endpoint)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerDocumentByDocumentType = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .get(params.endpoint)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const exportLotList = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, { responseType: "blob" })
    .get(`/api/lots/export?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response, true);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectCostCode = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`api/projects/${params.projectId}/cost-code-select-list`)
    .then((response) => {
      return MapResponse(response, true);
    })
    .catch((error) => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getInventoryCategory = (params) => {
  return Jwt(params.headers.url)
    .get(`/api/v2/homeowner/inventory/category/all/${params.lotId}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSmartApp = (params) => {
  return (
    Jwt(params.builderHost)
      // .get(
      //   `/api/v2/homeowner/smart-app/list/all/${1}?subDomain=${params.subDomain}`
      // )
      // .then((response) => {
      //   return MapResponse(response);
      // })
      // .catch((error) => {
      //   var response = error.response;
      //   return MapResponse(response);
      // });
      .get(`/api/v2/homeowner/smart-app/list/all/false`)
      .then((response) => {
        return MapResponse(response);
      })
      .catch((error) => {
        var response = error.response;
        return MapResponse(response);
      })
  );
};

export const getItemDetailInventory = (params) => {
  return Jwt(params.headers.url)
    .get(
      `/api/v2/homeowner/inventory/items/${params.categoryId}?lotId=${params.lotId}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteInventoryCategory = (params) => {
  return Jwt(params.url)
    .get(
      `/api/v2/homeowner/inventory/category/${params.lotId} /delete/${params.categoryId}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteInventoryItem = (params) => {
  return Jwt(params.url)
    .delete(`/api/v2/homeowner/inventory/items/${params.itemId}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addInventoryCategory = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/inventory/category/addupdate`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addNewInventoryItem = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/inventory/items/add`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateHomeownerInventoryItem = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/inventory/items/update`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateInventoryCategory = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/inventory/category/addupdate`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getInventoryCategoryItem = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/inventory/items/category/all/items`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getUploadFile = (params) => {
  return Jwt(params.headers.url, "multipart/form-data")
    .post(`/api/v2/homeowner/inventory/items/add/file`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerHomeInventoryCategories = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .get(
      `${params.builderHost}/api/category-for-home-owners?lotId=${params.lotId}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerHomeInventoryCategoryItems = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.data.lotId },
    ],
  })
    .post(
      `${params.builderHost}/api/inventory-item-for-home-owners/get-list-inventory-items`,
      params.data
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeownerHomeInventoryCategoryItemsProfile = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .get(
      `${params.builderHost}/api/inventory-item-for-home-owners/${params.id}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editHomeownerHomeInventoryCategoryItemsProfile = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .put(
      `${params.builderHost}/api/inventory-item-lot-for-home-owners`,
      params.data
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getCategoryProfileDetails = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .get(`${params.builderHost}/api/category-for-home-owners/${params.id}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getTaskReminderListForHomeowner = (params) => {
  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.lotId },
    ],
  })
    .get(
      `${
        params.builderHost
      }/api/portal-homeowners/maintenance-schedule-reminders/get-reminders?lotId=${
        params.lotId
      }&from=${encodeURIComponent(params.fromDate)}&to=${encodeURIComponent(
        params.toDate
      )}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const updateTaskReminderWithId = (params) => {
  let url =
    params.builderHost +
    (params.isGeneral
      ? "/api/portal-homeowners/maintenance-schedule-reminders/check-or-uncheck-general-reminder"
      : "/api/portal-homeowners/maintenance-schedule-reminders/check-or-uncheck-inventory-specific-reminder");

  let body = {
    Id: params.id,
    IsChecked: params.isChecked + 0,
  };

  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.LotId },
    ],
  })
    .patch(url, body)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const updateTaskReminderWithoutId = (params) => {
  let body = { ...params };

  delete body.headers;
  delete body.builderHost;

  return Jwt(null, true, {
    headers: [
      { key: params.headers.key, value: params.headers.value },
      { key: "Key", value: params.LotId },
    ],
  })
    .patch(
      `${params.builderHost}/api/portal-homeowners/maintenance-schedule-reminders/check-abstract-reminder`,
      body
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      const response = error.response;
      return MapResponse(response);
    });
};

// export const getHomeownerHomeInventoryCategories = params => {
//   return Jwt(null, true, {
//     headers: [
//       { key: params.headers.key, value: params.headers.value },
//       { key: 'Key', value: params.lotId }
//     ]
//   })
//     .get(
//       `${params.builderHost}/api/category-for-home-owners?lotId=${params.lotId}`
//     )
//     .then(response => {
//       return MapResponse(response);
//     })
//     .catch(error => {
//       var response = error.response;
//       return MapResponse(response);
//     });
// };

export const getItemsListBaseonlot = (params) => {
  return Jwt(params.headers.url)
    .get(`/api/v2/homeowner/maintainence/item-list/${params.lotId}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const createReminder = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/maintainence/add`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getReminderLists = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/maintainence/list`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getInventoryByID = (params) => {
  return Jwt(params.headers.url)
    .get(
      `/api/v2/homeowner/inventory/items/${params.data.itemid}?lotId=${params.data.lotid}`
    )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSpecificReminder = (params) => {
  return Jwt(params.headers.url)
    .get(`api/v2/homeowner/maintainence/${params.data.lotid}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateInventoryByID = (params) => {
  return Jwt(params.url)
    .post(`/api/v2/homeowner/inventory/items/update`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateReminder = (params) => {
  return Jwt(params.headers.url)
    .post(`/api/v2/homeowner/maintainence/update`, params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteReminder = (params) => {
  return Jwt(params.headers.url)
    .delete(`/api/v2/homeowner/maintainence/${params.data.lotid}`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const onchangeUpdateReminder = (params) => {
  return Jwt(params.headers.url)
    .post(`api/v2/homeowner/maintainence/closed-reminder`, {
      ReminderId: params.data.reminderId,
      ReminderDate: params.data.reminderDate,
      LotId: params.data.lotId,
    })
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getDefaultLot = () => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/v1/defaultlots`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const postDefaultlotsAdd = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`api/v1/defaultlots/add`, {
      ReminderId: params.data.reminderId,
      ReminderDate: params.data.reminderDate,
      LotId: params.data.lotId,
    })
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Lots/api.js